import { render, staticRenderFns } from "./BasketList.vue?vue&type=template&id=354088c4&"
import script from "./BasketList.vue?vue&type=script&lang=js&"
export * from "./BasketList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/plugin-ceres/plugin-ceres/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('354088c4')) {
      api.createRecord('354088c4', component.options)
    } else {
      api.reload('354088c4', component.options)
    }
    module.hot.accept("./BasketList.vue?vue&type=template&id=354088c4&", function () {
      api.rerender('354088c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/basket/list/BasketList.vue"
export default component.exports